import styled from "styled-components";
import Col from "antd/lib/col";
import config from "../../staticConfig";

export const StyledContainer = styled.div`
  max-width: 757px;
  margin-top: 12px;
`;
export const StyledNoteContainer = styled.div`
  max-width: 757px;
  border-radius: 2px;
  background-color: ${config.themeConfig.noteBodyBackgroundColor};
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 15px;
  margin-bottom: 12px;
  .paddingTop {
    padding-top: 12px;
  }
  .subject {
    color: ${config.themeConfig.buttonBackgroundColor};
    //font-family: "PingFang SC";
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
  }
  .header {
    color: rgba(0, 21, 41, 0.7);
    //font-family: "PingFang SC";
    font-size: 12px;
    letter-spacing: 0.3px;
    line-height: 17px;
  }
  .alignPaddingLeft {
    padding-left: 30px;
  }
`;

export const StyledNote = styled(Col)`
  color: ${config.themeConfig.buttonBackgroundColor};
  //font-family: "PingFang SC";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
`;

export const StyledIconWrapper = styled.div`
  padding-top: 6px;
`;

export const StyledContentWrapper = styled.div`
  word-break: break-all;
`;
